import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import VendorExitFreespinsState from "../../../vendor_core/src/states/VendorExitFreespinsState";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import { GameHowl } from "../../../vendor_core/core/src/utils/GameHowl";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { Tween } from "../../../vendor_core/core/src/Tween";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIModes, UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import GameSoundVars from "../enums/GameSoundVars";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import BackgroundHelper from "../view/background/BackgroundHelper";
import { Ease } from "../../../vendor_core/core/src/Ease";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import { Timeline } from "../../../vendor_core/core/src/Timeline";
import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import Locale from "../../../vendor_core/core/src/utils/Locale";
import { State } from "../../../vendor_core/core/src/states/State";
import InstanceFactory from "../../../vendor_core/core/src/factories/InstanceFactory";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import KeyboardManager from "../../../vendor_core/core/src/utils/KeyboardManager";
import { UIButtons } from "../../../vendor_core/core/src/ui/UIButtons";
import SwitchButton from "../../../vendor_core/core/src/views/components/SwitchButton";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import { VendorCommandsEnum } from "../../../vendor_core/src/commands/VendorCommandsEnum";

export default class MYSEnterFreespinsState extends State {
    private outroAnimDuration: number = 5;
    protected winMusic: GameHowl | undefined;
    private isSceneClosed = false;
    private sceneName: string = "";
    private spineSkin: string = "";

    public enter() {
        // Set popup
        this.sceneName = SpinModel.featureMode === 2 ? "freespinssummaryBH1" : "freespinssummaryBH2";
        this.spineSkin = SpinModel.featureMode === 2 ? "sticky" : "black";

        KeyboardManager.disable();
        CommandManager.execute(VendorCommandsEnum.FEATURE_STARTED);
        VendorModel.spinStartTime = 0;
        super.enter();
        this.isSceneClosed = false;

        if (!UIController.isComponentHidden("settings")) {
            InstanceFactory.getClass("Settings").hide()
        }

        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        reelGroup.winSymbolsView.unlockAll();
        reelGroup.winSymbolsView.stopAll();
        reelGroup.hideLinesAndInfo(true);

        // Sebastian wants turbo to be disabled on free spins
        if (GameModel.turboSpin) {
            CommandManager.execute(Commands.TOGGLE_TURBO_SPIN);
        }

        this.showPopup();
    }

    public showPopup() {
        App.dispatcher.emit(`${GameEvents.SHOW_FREE_SPIN_INTRO}_${SpinModel.featureMode}`);
        SoundController.playSound(`${GameSoundVars.FREE_SPINS_INTRO}_${SpinModel.featureMode - 1}`);
        ViewManager.getLayer("SplashOverlay").setScene("open");

        // const sceneFsCounter = ViewManager.getLayer(DefaultLayers.FreespinCounter).setScene("open");
        // let counter = sceneFsCounter.sceneTextFields.get("fs_counter");
        // counter.visible = false;

        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(this.sceneName);
        CommandManager.execute(Commands.UPDATE_FREE_SPINS);
        scene.interactive = true;


        const explosionEffect = scene.spineAnimations.get("fsIntroOutro");
        explosionEffect.setAnimationSkin(this.spineSkin);
        explosionEffect.playAsync("intro_start").then(() => explosionEffect.playAsync("intro_loop"));
        const headerTxt = scene.sceneTextFields.get("header");
        headerTxt.alpha = 0;
        const title2 = scene.sceneTextFields.get("title2") as TextField;
        title2.alpha = 0;
        const clickToStart = scene.sceneTextFields.get("click_to_start") as TextField;
        clickToStart.alpha = 0;
        headerTxt.text = Locale.getString("fs_summary_header");

        let winMoney = scene.sceneMoneyFields.get("win_counter");
        winMoney.value = SpinModel.accumulatedWin;
        winMoney.alpha = 0;
        let timeline = new Timeline({
            autoRemoveChildren: false,
            // to use it when autoplay mode is complete
            // onComplete: () => {
            //     Tween.delayedCall(this.outroAnimDuration, () => {
            //         if (!this.isSceneClosed) {
            //             timeline.reverse(0);
            //             explosionEffect.playAsync("intro_end")
            //                 .then(() => {
            //                     this.closePopup(scene);
            //                     timeline.clear;
            //                     timeline.kill();
            //                 });
            //         }
            //     });
            // }
        });

        timeline
            .to(headerTxt, 0.5, { delay: 0, alpha: 1, ease: Ease.Power4In }, 0)
            ///.to(winMoney, 1.2, { delay: 0, alpha: hasWin ? 1 : 0, ease: Ease.Power4In }, 0)
            .to(title2, 1, { delay: 0, alpha: 1, ease: Ease.Power4In }, 0)
            .to(clickToStart, 2.2, { delay: 0, alpha: 1, ease: Ease.Power4In }, 0)

        timeline.play();
        Tween.delayedCall(2, () => {
            scene.once(PointerEvents.DOWN, () => {
                App.dispatcher.emit(`${GameEvents.FREE_SPIN_INTRO_CLOSED}_${SpinModel.featureMode}`);
                timeline.reverse(0);
                explosionEffect.playAsync("intro_end")
                    .then(() => {
                        this.closePopup(scene);
                        timeline.progress = 1;
                        timeline.clear;
                        timeline.kill();
                    });
            })
        });


    }

    public closePopup(scene: SceneView) {
        if (!this.isSceneClosed) {

            this.isSceneClosed = true;

            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            reelGroup.winSymbolsView.unlockAll();
            reelGroup.winSymbolsView.stopAll();
            reelGroup.hideLinesAndInfo(true);
            ViewManager.getLayer(DefaultLayers.Popups).clear();
            ViewManager.getLayer("FreespinCounter").clear();
           ////// BackgroundHelper.backgrounFsClose().then(BackgroundHelper.backgroundLoop);

            UIController.setState(UIStates.IDLE);
            UIController.setMode(UIModes.DEFAULT);

            ViewManager.getLayer("SplashOverlay").clear();
            SpinModel.exitFreespins();

            if (this.winMusic) {
                SoundController.stopSound(this.winMusic);
            }

            reelGroup.revealAllSymbols();
            scene.destroy();

            this.exit();
        }
    }

}
